import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { Link as LinkTo } from 'react-router';
import { PageTopBar, TwoSlotLayout } from "../../../../../common/components/page_top_bar";
import { useRequisicaoServicosProdutosCadastroViewModel } from "../../viewModels/requisicao_servicos_produtos_cadastro_view_model";
import { BackButton } from "../../../../../common/components/back_button";
import { PopperButton } from "../../../../../common/components/popper_button";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { DefaultFormAutocomplete } from "../../../../../common/components/default_form_autocomplete";
import { DefaultFormDatePickerInput } from "../../../../../common/components/default_form_date_picker_input";
import { CentroCustoDrawer } from "../../../../../common/components/drawers_api/drawers/centro_custo_drawer";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { GenerateServicoProdutoColumnDefinition, GenerateHistoricoColumnDefinition } from "./columns";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { RequisicaoProdutoServicoLista } from "../../../domain/models/requisicao_produto_servico_lista";
import { DefaultFormDownloadInput } from "../../../../../common/components/default_form_download_input";
import { AlteracaoRequisicaoProdutoServico } from "../../../domain/models/alteracao_requisicao_produto_servico";
import { RequisicaoProdutoServicoModal } from "./components/requisicao_produto_servico_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { isValidId } from "../../../../../common/utils/utils";
import { ProdutoServicoDrawer } from "../../../../../common/components/drawers_api/drawers/produto_servico_drawer";
import { HeaderItemNro } from "../../../../../common/components/header_item_nro";

import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import BottomBar from "../../../../../common/components/bottom_bar";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import dayjs from "dayjs";

/**
 * RequisicaoServicosProdutosCadastro
 */

export const RequisicaoServicosProdutosCadastro = () => {
  const viewModel = useRequisicaoServicosProdutosCadastroViewModel();

  const servicosProdutosColumnsDefinition = useMemo(() => {
    return GenerateServicoProdutoColumnDefinition({
      status: viewModel.status,
      onActionEditar: viewModel.handleRequisicaoProdutoServicoOpenState,
      onActionDeletar: viewModel.handleRequisicaoProdutoServicoDeleteOpenState,
    });
  }, [
    viewModel.status,
    viewModel.handleRequisicaoProdutoServicoOpenState,
    viewModel.handleRequisicaoProdutoServicoDeleteOpenState,
  ]);

  const historicoColumnsDefinition = useMemo(() => {
    return GenerateHistoricoColumnDefinition();
  }, [
  ]);

  return (
    <>
      {/**
        * PageTopBar
        */}

      <PageTopBar>
        <TwoSlotLayout
          leftSlot={
            <div className="flex flex-row gap-2 items-center">
              <FormRadioGroupInput
                name='status'
                options={viewModel.statusOptions}
                readOnly={viewModel.status === 3}
                reactHookForm={viewModel.hookForm}
                onValueChange={viewModel.handleStatusChangeSubmit}
              />
              {
                (viewModel.idRequisicaoCompra && viewModel.requisicaoCompra) &&
                <div className="flex flex-row items-center gap-2">
                  {
                    viewModel.requisicaoCompra.nrRequisicaoCompra &&
                    <div className="w-[4rem]">
                      <HeaderItemNro
                        label="Número"
                        value={viewModel.requisicaoCompra.nrRequisicaoCompra}
                      />
                    </div>
                  }
                  {
                    (viewModel.atributoCompra && viewModel.atributoCompra.exibirDataCadastro) &&
                    <div className="w-[6rem]">
                      <HeaderItemNro
                        label="Data Cadastro"
                        value={
                          viewModel.requisicaoCompra.dataCadastro
                            ? dayjs(viewModel.requisicaoCompra.dataCadastro).format('DD/MM/YYYY')
                            : null
                        }
                      />
                    </div>
                  }
                </div>
              }
            </div>
          }
          rightSlot={
            <div className="flex flex-row gap-2">
              {
                (viewModel.idRequisicaoCompra && viewModel.enableColetaPreco) &&
                <div className="w-[11rem]">
                  <PrimaryButton
                    buttonColor="secondary"
                    onMouseDown={e => {
                      if (e.button === 1) {
                        viewModel.handleNovaColetaPrecos(true);
                      } else {
                        viewModel.handleNovaColetaPrecos(e.ctrlKey);
                      }
                      e.preventDefault();
                    }}>
                    Nova Coleta de Preços
                  </PrimaryButton>
                </div>
              }

              <div className="w-[115px]">
                <PopperButton
                  buttonLabel='Opções'
                  buttonColor='yellow'
                  options={viewModel.buttonOptions}
                  onSelect={viewModel.handleOptionPopperActions}
                />
              </div>

              <BackButton
                onClick={viewModel.handleBack}
              />
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}
      <form onSubmit={viewModel.handleSubmit}>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Compras
            </Link>
            <Link underline="hover" color="inherit" component='span'>
              <LinkTo to="/RequisicaoServicosProdutos_lista" >
                Requisição de Produtos e Serviços
              </LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Cadastro de Requisição de Material ou Serviço
            </Typography>
          </Breadcrumbs>

          <div className="flex flex-col gap-2">
            <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
              <div className="flex gap-2 items-center w-full">
                <h1 className="text-3xl font-medium text-black dark:text-white">
                  Cadastro de Requisição de Material ou Serviço
                </h1>
                <RefreshButton onClick={viewModel.handleReload} />
              </div>
            </div>
          </div>
          {
            viewModel.errorMessage !== undefined
              ? (
                <div className="w-full">
                  <AlertError
                    messageErro={viewModel.errorMessage}
                    onTryAgain={viewModel.handleReload}
                  />
                </div>
              ) : (
                <>
                  {
                    (viewModel.status !== 0 && viewModel.status !== 2) &&
                    <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-y-4 gap-x-2 p-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border border-border-light-mode dark:border-border-dark-mode text-black dark:text-white">
                      <div className="grid grid-cols-1 md:grid-cols-2 col-span-1 md:col-span-2 lg:col-span-3 gap-2">
                        <div className="col-span-1">
                          <DefaultFormAutocomplete
                            name='aprovadoPor'
                            label='Aprovada Por'
                            getOptionDisabled={opt => !opt.canBeSelected}
                            options={viewModel.funcionariosAprovadosDropdown}
                            getOptionKey={x => x.idFuncionario}
                            getOptionLabel={x => x.nome}
                            required={true}
                            readOnly={viewModel.status !== 1}
                            reactHookForm={viewModel.hookForm}
                          />
                        </div>

                        <div className="col-span-1">
                          <DefaultFormDatePickerInput
                            name='dataAprovadoPor'
                            label='Data'
                            required={true}
                            readOnly={viewModel.status !== 1}
                            reactHookForm={viewModel.hookForm}
                          />
                        </div>
                      </div>
                    </div>
                  }
                  <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-y-4 gap-x-2 p-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border border-border-light-mode dark:border-border-dark-mode text-black dark:text-white">
                    {/*
                    <div className="w-full col-span-1 md:col-span-2 xl:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-2">
                      <DefaultFormInput
                        name='nro'
                        label='Nº'
                        readOnly={true}
                        reactHookForm={viewModel.hookForm}
                      />

                      {
                        (viewModel.atributoCompra && viewModel.atributoCompra.exibirDataCadastro) &&
                        <DefaultFormDatePickerInput
                          name='dataCadastro'
                          label='Data de Cadastro'
                          readOnly={true}
                          reactHookForm={viewModel.hookForm}
                        />
                      }
                    </div>
                    */}

                    <div className="w-full col-span-1 md:col-span-2 xl:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-2">
                      <DefaultFormAutocomplete
                        name='solicitante'
                        label='Solicitante'
                        getOptionDisabled={x => !x.canBeSelected}
                        options={viewModel.funcionariosSolicitanteDropdown}
                        getOptionKey={x => x.idFuncionario}
                        getOptionLabel={x => x.nome}
                        required={true}
                        readOnly={viewModel.lockSolicitante || viewModel.lockEdition}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormDatePickerInput
                        name='dataRequisicao'
                        label='Data da Requisição'
                        readOnly={viewModel.lockEdition}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                    <div className="w-full col-span-1 md:col-span-2 xl:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-2">
                      <DefaultFormAutocomplete
                        name='centroCusto'
                        label='Centro de Custo'
                        options={viewModel.centroCustoDropdown}
                        getOptionKey={x => x.id}
                        getOptionLabel={x => x.title}
                        required={true}
                        readOnly={viewModel.lockEdition}
                        newButtonLabel="Novo item"
                        onNew={viewModel.handleCreateCentroCusto}
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormDatePickerInput
                        name='dataPrevistaUtilizacao'
                        label='Data Prevista Utilização'
                        readOnly={viewModel.lockEdition}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                    <div className="w-full col-span-1 md:col-span-2 xl:col-span-3">
                      <DefaultFormInput
                        name='descricao'
                        label='Descrição'
                        readOnly={viewModel.lockEdition}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                    <div className="w-full col-span-1 md:col-span-2 xl:col-span-3">
                      <DefaultFormInput
                        name='observacao'
                        label='Observações'
                        multiline={true}
                        rows={8}
                        readOnly={viewModel.lockEdition}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>
                  </div>

                  <div className="w-full flex flex-col gap-2 p-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border border-border-light-mode dark:border-border-dark-mode text-black dark:text-white">
                    {
                      viewModel.idRequisicaoCompra &&
                      <>
                        <div className="w-full flex flex-col gap-2">
                          <div className="flex flex-row items-center justify-between">
                            <h1 className="font-bold text-black dark:text-white">Serviços/Produtos</h1>
                            <div>
                              {
                                (viewModel.status === 0 || viewModel.status === 4) &&
                                <PrimaryButton
                                  buttonColor="primary-green"
                                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                  onMouseDown={e => {
                                    viewModel.handleProdutoServicoOpenState(true);
                                    e.preventDefault();
                                  }}>
                                  Novo Item
                                </PrimaryButton>
                              }
                            </div>
                          </div>

                          <Stack spacing={0}>
                            <StyledDataGrid
                              tableName="requisicao_servicos_produtos_produtos"
                              disableColumnMenu={false}
                              autoHeight={true}
                              height="50rem"
                              getRowId={(row: RequisicaoProdutoServicoLista) => row.idRequisicaoProdutoServico}
                              columns={servicosProdutosColumnsDefinition}
                              loading={viewModel.loading}
                              disableRowSelectionOnClick={true}
                              rows={viewModel.requisicaoServicosProdutos}
                              rowCount={viewModel.requisicaoServicosProdutos.length}
                              pageSizeOptions={[10, 25, 50, 100]}
                              paginationMode="server"
                              paginationModel={{
                                page: viewModel.pagination.requisicaoProdutosServicos.page,
                                pageSize: viewModel.pagination.requisicaoProdutosServicos.rowsPerPage,
                              }}
                            />

                            <TablePagination
                              component="div"
                              count={viewModel.pagination.requisicaoProdutosServicos.totalItems}
                              page={viewModel.pagination.requisicaoProdutosServicos.page - 1}
                              onPageChange={(_, p) => viewModel.handleRequisicaoServicoProdutoPageChange(p)}
                              rowsPerPageOptions={[10, 25, 50, 100]}
                              rowsPerPage={viewModel.pagination.requisicaoProdutosServicos.rowsPerPage}
                              onRowsPerPageChange={(e) => viewModel.handleRequisicaoServicoProdutoRowsPerPageChange(parseInt(e.target.value))}
                            />

                          </Stack>
                        </div>
                      </>
                    }
                    {
                      viewModel.idRequisicaoCompra &&
                      <>
                        <div className="w-full flex flex-col gap-2">
                          <h1 className="font-bold">Histórico de alterações serviços/produtos</h1>
                          <Stack spacing={0}>
                            <StyledDataGrid
                              tableName="requisicao_servicos_produtos_produtos"
                              disableColumnMenu={false}
                              autoHeight={true}
                              getRowId={(row: AlteracaoRequisicaoProdutoServico) => row.idAlteracaoRequisicaoProdutoServico}
                              columns={historicoColumnsDefinition}
                              loading={viewModel.loading}
                              disableRowSelectionOnClick={true}
                              rows={viewModel.alteracaoRequisicaoProdutosServicos}
                              rowCount={viewModel.alteracaoRequisicaoProdutosServicos.length}
                              pageSizeOptions={[10, 25, 50, 100]}
                              paginationMode="server"
                              paginationModel={{
                                page: viewModel.pagination.alteracaoRequisicaoProdutosServicos.page,
                                pageSize: viewModel.pagination.alteracaoRequisicaoProdutosServicos.rowsPerPage,
                              }}
                            />

                            <TablePagination
                              component="div"
                              count={viewModel.pagination.alteracaoRequisicaoProdutosServicos.totalItems}
                              page={viewModel.pagination.alteracaoRequisicaoProdutosServicos.page - 1}
                              onPageChange={(_, p) => viewModel.handleAlteracaoRequisicaoServicoProdutoPageChange(p)}
                              rowsPerPageOptions={[10, 25, 50, 100]}
                              rowsPerPage={viewModel.pagination.alteracaoRequisicaoProdutosServicos.rowsPerPage}
                              onRowsPerPageChange={(e) => viewModel.handleAlteracaoRequisicaoServicoProdutoRowsPerPageChange(parseInt(e.target.value))}
                            />

                          </Stack>
                        </div>
                      </>
                    }
                    <div className="w-full flex flex-col gap-2">
                      <h1 className="font-bold text-xl">Anexar documentos</h1>
                      <div className="w-[45rem] flex flex-col gap-4 ps-[5rem] mt-[2rem] mb-[5rem]">
                        <DefaultFormDownloadInput
                          name='arquivo1'
                          nameLimparFlag='limparArquivo1'
                          saving={viewModel.saving}
                          filename={viewModel.requisicaoCompra?.nomearquivo1 ?? null}
                          maxFilenameSize={70}
                          reactHookForm={viewModel.hookForm}
                          onDeleteFile={() => viewModel.handleDeleteFile(1)}
                          onDownloadFile={(_) => {
                            if (viewModel.requisicaoCompra !== null) {
                              viewModel.handleDownloadFile(1, viewModel.requisicaoCompra.nomearquivo1 ?? "");
                            }
                          }}
                        />

                        <DefaultFormDownloadInput
                          name='arquivo2'
                          nameLimparFlag='limparArquivo2'
                          saving={viewModel.saving}
                          filename={viewModel.requisicaoCompra?.nomearquivo2 ?? null}
                          maxFilenameSize={70}
                          reactHookForm={viewModel.hookForm}
                          onDeleteFile={() => viewModel.handleDeleteFile(2)}
                          onDownloadFile={(_) => {
                            if (viewModel.requisicaoCompra !== null) {
                              viewModel.handleDownloadFile(2, viewModel.requisicaoCompra.nomearquivo2 ?? "");
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )
          }
        </div>

        {/**
          * BottomBar
          */}

        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {
                isValidId(viewModel.idRequisicaoCompra) &&
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                  <span className="text-xs">
                    Historico de alterações
                  </span>
                </PrimaryButton>
              }
            </div>

            <div className="flex flex-row gap-4">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={viewModel.handleBack}>
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving
                  ? (
                    <PrimaryButton>
                      Salvando...
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      type="submit"
                      startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                      Salvar
                    </PrimaryButton>
                  )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>

      {/**
        * Modals
        */}

      <CentroCustoDrawer
        saving={viewModel.saving}
        state={viewModel.centroCustoDrawerState}
      />

      <ProdutoServicoDrawer
        saving={viewModel.saving}
        state={viewModel.produtoServicoDrawerState}
      />

      <RequisicaoProdutoServicoModal
        open={viewModel.requisicaoProdutoServicoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        produtosServicosDropdown={viewModel.produtosServicosDropdown}
        subcontasDropdown={viewModel.subcontasDropdown}
        selectedRequisicaoProdutoServico={viewModel.selectedRequisicaoProdutoServico}
        onClose={() => viewModel.handleRequisicaoProdutoServicoOpenState(null, false)}
        onSubmit={viewModel.handleRequisicaoProdutoServicoSubmit}
        onNewProdutoServico={viewModel.handleNewProdutoServico}
      />

      <DeleteDialog
        open={viewModel.requisicaoCompraDeleteModal}
        saving={viewModel.saving}
        title='Você realmente deseja excluir este item?'
        onClose={() => viewModel.handleRequisicaoCompraDeleteOpenState(false)}
        onDelete={() => viewModel.handleRequisicaoCompraDeleteSubmit()}
      />

      <DeleteDialog
        open={viewModel.requisicaoProdutoServicoDeleteModal}
        saving={viewModel.saving}
        title='Você realmente deseja excluir este item?'
        onClose={() => viewModel.handleRequisicaoProdutoServicoDeleteOpenState(null, false)}
        onDelete={() => viewModel.handleRequisicaoProdutoServicoDeleteSubmit()}
      />

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />
    </>
  );
}